<template>
  <div class="c-box-button">
    <button
      role="button"
      :class="{ 'active': active === true }"
      @click="onClick(name)"
    >
      {{ text }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'CBoxButton',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    text: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClick (value) {
      this.$emit('click', value)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../../../../../resources/css/variables';

.c-box-button {
  button {
    padding: 30px;
    width: 100%;
    color: #282828;
    background-color: #fff;
    border: 0 solid transparent;
    border-radius: 20px;
    outline: none;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
    text-align: left;
    touch-action: manipulation;
    user-select: none;
    -webkit-user-select: none;
    cursor: pointer;
    @media all and (max-width: $mdBreakpoint - 1) {
      padding: 20px;
      font-size: 16px;
      border-radius: 12px;
    }
    &:active,
    &:hover {
      color: #fff;
    }
    &:hover {
      background-color: #dd4b39;
      border-color: #d73925;
    }
    &:active {
      background-color: #d73925;
      border-color: #ac2925;
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.1);
      //outline: 5px auto -webkit-focus-ring-color;
      //outline-offset: -2px;
    }
    &:focus-visible {
      box-shadow: none;
    }
    &.active {
      color: #fff;
      background-color: #dd4b39;
      border-color: #d73925;
      &:hover,
      &:active {
        background-color: #d73925;
        border-color: #ac2925;
      }
      &:active {
        background-color: #ac2925;
        border-color: #761c19;
      }
    }
  }
}
</style>
